<script setup lang="ts">
    import AppLayout from '@/layouts/AppLayout.vue';
    import PageCard from '@/components/PageCard.vue';
    import { Head } from '@inertiajs/vue3';
    import { Company } from '@/types';
    import CustomerDashboardBanner from '@/components/customer-dashboard/CustomerDashboardBanner.vue';
    import CustomerDashboardTasks from '@/components/customer-dashboard/CustomerDashboardTasks.vue';
    import CustomerDashboardProcedures from '@/components/customer-dashboard/CustomerDashboardProcedures.vue';
    import PowerBI from '@/components/PowerBI.vue';
    import { usePermissions } from '@/composables/usePermissions';
    import Permission from '@/enums/Permission';

    defineProps<{
        company?: Company;
    }>();

    const { hasPermission } = usePermissions();
</script>

<template>
    <Head :title="$t('dashboards.title')" />

    <AppLayout
        :breadcrumbs="[]"
        hide-header
        require-selected-company
        content-class="overflow-hidden"
    >
        <div
            v-if="company"
            class="flex min-h-0 flex-1 flex-col"
        >
            <div
                class="flex h-full min-h-0 w-full flex-1 flex-col overflow-x-hidden overflow-y-auto"
            >
                <CustomerDashboardBanner :company="company" />
                <PageCard
                    v-if="hasPermission(Permission.POWERBI_VIEW) && company.services.has_power_bi"
                    class="mb-0 h-auto flex-none"
                >
                    <PowerBI />
                </PageCard>
                <div class="grid flex-1 gap-1.5 md:grid-cols-2">
                    <CustomerDashboardTasks :company="company" />
                    <CustomerDashboardProcedures :company="company" />
                </div>
            </div>
        </div>
    </AppLayout>
</template>
